import { baseRequest, request } from './base'

let appBaseUrlPrefix = '/api/ucuser'

function loadSelfInfo(successCB) {
  baseRequest('GET', appBaseUrlPrefix + '/v1/self/info', {}, function (data) {
    successCB(data)
  })
}

function getCoinTradeList(successCB) {
  baseRequest('GET', appBaseUrlPrefix + '/v1/cointrade/list', {}, function (data) {
    successCB(data)
  })
}
// 官网查询用户
function getChargeSearch(par, successCB, failCB) {
  request(
    'GET',
    appBaseUrlPrefix + '/v1/user/charge/search',
    par,
    data => {
      successCB(data)
    },
    (status, msg) => {
      failCB(msg)
    }
  )
}

export { loadSelfInfo, getCoinTradeList, getChargeSearch }
